import items from './items'
import tareas from './tareas'

export const itemsService = items
export const tareasService = tareas

